angular.module('bmsApp.employeeHoliday').controller('EmployeeHolidayModalFormCtrl', [
	'$scope',
	'$modalInstance',
	'$ngBootbox',
	'EmployeeOptionsSvc',
	'EmployeeHolidaySvc',
	'EmployeeSvc',
	'employee_holiday', function ($scope,
								  $modalInstance,
								  $ngBootbox,
								  EmployeeOptionsSvc,
								  EmployeeHolidaySvc,
								  EmployeeSvc,
								  employee_holiday) {

		$scope.datePickerConfig = angular.copy($scope.config.datePicker.basic);
		$scope.datePickerConfig.options.parentEl = '.modal-content';

		employee_holiday._end = null;
		employee_holiday._start = null;
		employee_holiday.end = null;
		employee_holiday.start = null;
		employee_holiday.source = null;

		$scope.validHoliday;
		$scope.employee_holiday = employee_holiday;
		$scope.employeeOptions = [];
		$scope.loading = true;
		$scope.processing = false;
		EmployeeSvc.index({
			filter: {
				status: true
			},
			sorting: {
				'full_name': 'asc'
			}

		})
			.then(function (response) {
				$scope.employeeOptions = response.data.employee_collection;
				$scope.loading = false;
			});
		$scope.timeOptions = [
			{
				value: 'am',
				label: 'AM'
			},
			{
				value: 'pm',
				label: 'PM'
			},
			{
				value: 'all',
				label: 'All Day'
			}
		];

		$scope.formvalidatorconfig = {
			submitHandler: function (form) {
				$scope.submit($scope.employee_holiday);
			},
			errorPlacement: function (error, element) {
				error.appendTo('#employee-holiday-errors');
			},
			errorContainer: '#employee-holiday-errors'
		};

		$scope.submit = function (employee_holiday) {
			$scope.processing = true;
			var modalResult = {};
			var savePromise = employee_holiday.id ? EmployeeHolidaySvc.update(employee_holiday) : EmployeeHolidaySvc.create(employee_holiday);
			savePromise
				.then(function (response) {
					modalResult.success = response.data.success;
					modalResult.action = employee_holiday.id ? 'update' : 'create';
					modalResult.employee_holiday = employee_holiday;
					$modalInstance.close(modalResult);
				}, function (error) {
					$scope.errors = error;
					//$modalInstance.close(modalResult);
				})
				.finally(function () {
					$scope.processing = false;
				});
		};

		$scope.delete = function (employee_holiday) {
			$ngBootbox.confirm('Are you sure you want to do this?')
				.then(function () {
					var modalResult = {};
					EmployeeHolidaySvc.delete(employee_holiday)
						.then(function (response) {
							modalResult.success = response.data.success;
							modalResult.action = 'delete';
							$modalInstance.close(modalResult);
						}, function (error) {
							modalResult.error = error;
							$modalInstance.close(modalResult);
						});
				});
		};

		$scope.cancel = function () {
			$modalInstance.dismiss('cancel');
		};

		$scope.check = function () {
			if ($scope.employee_holiday.employee) {
				EmployeeHolidaySvc.check($scope.employee_holiday)
					.then(function (response) {
						$scope.validHoliday = response.data.validHoliday;
					}, function () {
						$scope.validHoliday = false;
					});
			}
			else {
				$scope.validHoliday = true;
			}
		};

		$scope.$watch('validHoliday', function (newValue, oldValue) {
			console.log(newValue, oldValue);
			if (newValue === false) {
				$ngBootbox.alert('The employee has already booked holiday within the selected date range.')
					.then(function () {

					});
			}
		});

	}]);
